import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './calendar.scss';

import CalendarHeader from './CalendarHeader';
import { useInitializeDays, useScreenWidth } from '../../shared/Helpers/hooks';
import MonthView from './monthView';
import WeekView from './weekView';
import DayView from './dayView';
import CalendarPopups from './Actions';
import CalendarGadget from './Session/calendarGadget';
import AddSession from './Actions/addSession';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getEvents } from '../../redux/State/clientSlice/calendarSlice';
import { clearActiveTargets } from '../../redux/State/clientSlice/programTargetSlice';
import { getRoleConfigruation } from '../../redux/State/identitySlice/accountSlice';
import { AdminTypes } from '../../components/Menu';

const CalendarView = () => {
	useInitializeDays();

	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isSmallScreen = screenWidth >= 1024 && screenWidth <= 1600;

	const isMenuOpen = useSelector((state) => state.common.isMenuOpen);
	const view = useSelector((state) => state.calendarHelper.calendarView);
	const filterData = useSelector((state) => state.calendarHelper.filterData);
	const applyFilters = useSelector((state) => state.calendarHelper.filterData.applyFilters);
	const includeBTEvents = useSelector((state) => state.calendarHelper.filterData.includeBTEvents);
	const includeBCBAEvents = useSelector((state) => state.calendarHelper.filterData.includeBCBAEvents);
	const addEventOpen = useSelector((state) => state.calendarHelper.popups.addScheduled);
	const days = useSelector((state) => state.calendarHelper.displayedCalendarPageDays);
	const role = useSelector((state) => state.account.role);

	const clientId = filterData.client?.id;
	const userId = filterData.therapist?.id;
	const canFilterEvents = role?.section.id === AdminTypes.admin || role?.section.id === AdminTypes.cs;

	useEffect(() => {
		dispatch(clearActiveTargets());
		dispatch(getRoleConfigruation());
	}, [dispatch]);

	useEffect(() => {
		if (!days.length || addEventOpen || applyFilters) return;

		const eventData = canFilterEvents
			? { days, clientId, userId, includeBTEvents, includeBCBAEvents }
			: { days, includeBTEvents, includeBCBAEvents };
		dispatch(getEvents(eventData));
	}, [
		dispatch,
		clientId,
		userId,
		days,
		includeBCBAEvents,
		includeBTEvents,
		addEventOpen,
		applyFilters,
		canFilterEvents,
	]);

	const displayCalendarGadget = isSmallScreen ? !isMenuOpen : true;

	return (
		<div className="calendar">
			{displayCalendarGadget && (
				<div className="datePickerCard">
					<CalendarGadget />
					<AddSession />
				</div>
			)}
			<div className="calendarCard">
				<CalendarHeader />
				{view === 0 && <MonthView />}
				{view === 1 && <WeekView />}
				{view === 2 && <DayView />}
			</div>
		</div>
	);
};
const Calendar = () => (
	<>
		<CalendarView />
		<CalendarPopups />
	</>
);

export default Calendar;
